import { render, staticRenderFns } from "./PurchaseRecordItem.vue?vue&type=template&id=0abe178e&scoped=true"
import script from "./PurchaseRecordItem.vue?vue&type=script&lang=js"
export * from "./PurchaseRecordItem.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRecordItem.vue?vue&type=style&index=0&id=0abe178e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abe178e",
  null
  
)

export default component.exports